<web-settings-body>
    <web-settings-breadcrumbs>
        <div class="breadcrumb-icon">
            <a [tooltip]="'site_styles' | translate" placement="bottom" (click)="setSelectedTheme()">
                <img
                    src="./assets/img/websites/lpc-theme-settings-icon.svg"
                    class="first-breadcrumb-icon"
                    alt="lpc-theme-settings-icon"
                />
            </a>
            <img
                src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                class="breadcrumb-arrow-icon"
                alt="lpc-breadcrumb-arrow-icon"
            />
        </div>
        <div class="breadcrumb-icon">
            <img src="./assets/img/websites/lpc-block-icon.svg" class="first-breadcrumb-icon" alt="lpc-block-icon" />
        </div>
        <div class="breadcrumb-text">
            <span>{{ "control_block" | translate }}</span>
        </div>
    </web-settings-breadcrumbs>

    <a [href]="'knowledge_base_block_link' | translate" class="kb-link" target="_blank">
        <span class="small sp-icon icon-info"> </span> {{ "knowledge_base_block_tooltip" | translate }}
        <span class="color-light small sp-icon icon-outgoing"> </span>
    </a>

    <div class="panel-options-body overflow-wrapper">
        <div class="form form-horizontal">
            <div class="form-row">
                <div class="form-group mb-10">
                    <div class="col-xs-12 device-toggle-wrapper">
                        <web-device-toggle />

                        <web-synchronize-style-toggle [active]="syncWithDesktop()" (click)="setSynchronizeStyle()" />
                    </div>
                </div>

                <div class="form-group mb-0">
                    <p class="col-xs-12 help-block text-muted small">
                        {{ device() + "_device_hint" | translate }}
                    </p>
                </div>

                <!--
                    One section for every breakpoint: `device()` picks which values it
                    shows and every setter writes through `write()`, which fans the edit
                    out to all three while style synchronisation is on.
                -->
                <div class="form-group">
                    <label class="col-xs-9 control-label">
                        {{ "control_background_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <web-color-picker [color]="backgroundColor()" (colorChangeEvent)="setBackgroundColor($event)" />
                    </div>
                </div>

                <div class="form-group mb-15">
                    <label class="col-xs-7 control-label">
                        {{ "control_height" | translate }}
                    </label>
                    <div class="col-xs-5">
                        <sp-input-num
                            suffixText="px"
                            [min]="HEIGHT_MIN"
                            [value]="height()"
                            (valueChange)="setHeight($event)"
                        />
                    </div>
                </div>

                <div class="mb-15">
                    <web-background-image-settings
                        [background]="background()"
                        [disabled]="!!backgroundVideo()"
                        [allowScrollEffect]="!pinOnTheTop() && !pinOnTheBottom()"
                        (backgroundChange)="setBackground($event)"
                        (showEditImageModalEvent)="showEditImageModal()"
                        (unsplashClickRequested)="openUnsplashModal()"
                    />
                </div>

                <web-background-video-settings
                    [video]="backgroundVideo()"
                    [disabled]="!!backgroundImage()"
                    (videoChange)="setBackgroundVideo($event)"
                />

                <!-- The two edges take the same controls; only the shape strip differs. -->
                @for (edge of ["top", "bottom"]; track edge) {
                    @let divider = edge === "top" ? topDivider() : bottomDivider();

                    <div class="form-group mb-10">
                        <label class="col-xs-9 control-label">
                            {{ "control_" + edge + "_divider" | translate }}
                        </label>
                        <div class="col-xs-3 text-right">
                            <sp-switch
                                [active]="!!divider?.isEnabled"
                                (toggleActiveEvent)="setDividerEnabled($any(edge), $event)"
                            />
                        </div>
                    </div>

                    @if (divider?.isEnabled) {
                        <div class="well well-sm mb-15">
                            <div class="form-group mb-15">
                                <div class="appearance-wrapper">
                                    @for (variant of shapeDividerVariants; track variant) {
                                        <div
                                            class="appearance-block"
                                            [class.active]="divider?.view === variant"
                                            (click)="setDivider($any(edge), { view: variant })"
                                        >
                                            <img
                                                src="./assets/img/websites/shape-divider/lpc-shape-divider-{{
                                                    edge === 'bottom' ? 'b-' : ''
                                                }}{{ variant }}.svg"
                                            />
                                        </div>
                                    }
                                </div>
                            </div>

                            <div class="form-group mb-15">
                                <label class="col-xs-7 control-label">
                                    {{ "control_divider_color" | translate }}
                                </label>
                                <div class="col-xs-5">
                                    <web-color-picker
                                        [hideGradient]="true"
                                        [color]="divider?.color"
                                        (colorChangeEvent)="setDividerColor($any(edge), $event)"
                                    />
                                </div>
                            </div>

                            <div class="form-group mb-15">
                                <label class="col-xs-7 control-label">
                                    {{ "control_divider_height" | translate }}
                                </label>
                                <div class="col-xs-5">
                                    <sp-input-num
                                        suffixText="px"
                                        [min]="10"
                                        [max]="400"
                                        [value]="divider?.height"
                                        (valueChange)="setDivider($any(edge), { height: $event })"
                                    />
                                </div>
                            </div>

                            <div class="form-group mb-15">
                                <label class="col-xs-9 control-label">
                                    {{ "control_divider_repeat" | translate }}
                                </label>
                                <div class="col-xs-3">
                                    <sp-input-num
                                        [min]="1"
                                        [max]="5"
                                        [value]="divider?.repeat"
                                        (valueChange)="setDivider($any(edge), { repeat: $event })"
                                    />
                                </div>
                            </div>

                            <div class="form-group mb-10">
                                <label class="control-label col-xs-7">
                                    {{ "control_divider_flip" | translate }}
                                </label>
                                <div class="col-xs-5">
                                    <div
                                        class="btn-group btn-group-justified btn-group-with-tooltip three-items"
                                        data-toggle="buttons"
                                    >
                                        <button
                                            class="btn btn-grey"
                                            [class.active]="
                                                divider?.horizontalFlip === EBlockShapeDividerFlip.HORIZONTAL
                                            "
                                            (click)="toggleDividerFlip($any(edge), 'horizontal')"
                                        >
                                            <img
                                                src="./assets/img/websites/lpc-flip-horizontal-icon.svg"
                                                alt="Horizontal"
                                            />
                                        </button>
                                        <button
                                            class="btn btn-grey"
                                            [class.active]="divider?.verticalFlip === EBlockShapeDividerFlip.VERTICAL"
                                            (click)="toggleDividerFlip($any(edge), 'vertical')"
                                        >
                                            <img
                                                src="./assets/img/websites/lpc-flip-vertical-icon.svg"
                                                alt="Vertical"
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                }

                <div class="form-group mb-10">
                    <label class="control-label col-xs-9">
                        {{ "control_contour" | translate }}
                    </label>
                    <div class="col-xs-3 control-switch text-right">
                        <sp-switch [active]="isBorder()" (toggleActiveEvent)="setIsBorder($event)" />
                    </div>
                </div>

                @if (isBorder()) {
                    <sp-advanced-border-settings
                        [borderSettings]="borderSettings()"
                        (valueChangeEvent)="setAdvancedBorderSettings($event)"
                    />
                }

                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="control-label col-xs-6">
                        {{ "control_hide_block" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <div class="btn-group btn-group-justified btn-group-with-tooltip" data-toggle="buttons">
                            <button
                                class="btn btn-grey"
                                [class.active]="hidden()?.desktop"
                                [tooltip]="onDesktopTooltip"
                                (click)="toggleHiddenOn('desktop')"
                            >
                                <ng-template #onDesktopTooltip>
                                    {{ "control_hide_on_desktop_tooltip" | translate }}
                                </ng-template>
                                <img src="./assets/img/websites/lpc-desktop-icon.svg" alt="Hide on desktop" />
                            </button>
                            <button
                                class="btn btn-grey"
                                [class.active]="hidden()?.tablet"
                                [tooltip]="onTabletTooltip"
                                (click)="toggleHiddenOn('tablet')"
                            >
                                <ng-template #onTabletTooltip>
                                    {{ "control_hide_on_tablet_tooltip" | translate }}
                                </ng-template>
                                <img src="./assets/img/websites/lpc-tablet-icon.svg" alt="Hide on tablet" />
                            </button>
                            <button
                                class="btn btn-grey"
                                [class.active]="hidden()?.mobile"
                                [tooltip]="onMobileTooltip"
                                (click)="toggleHiddenOn('mobile')"
                            >
                                <ng-template #onMobileTooltip>
                                    {{ "control_hide_on_mobile_tooltip" | translate }}
                                </ng-template>
                                <img src="./assets/img/websites/lpc-mobile-icon.svg" alt="Hide on mobile" />
                            </button>
                        </div>
                    </div>
                </div>

                @if (isAdmin()) {
                    <hr class="panel-options-divider" />
                    <web-block-library-addon [blockId]="entity().id" />
                }
            </div>
        </div>

        <div class="mt-20">
            <web-custom-id [displayId]="displayId()" (valueChangeEvent)="setDisplayId($event)" />
        </div>
    </div>
</web-settings-body>
